import React from 'react';

import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

const DynamicLoadProgressContainer = (props) => {
  const style = { height: '100%' };

  return (
    <Grid container alignItems="center" justifyContent="center" style={style}>
      <Grid item>
        <CircularProgress size={props.small ? 50 : 100} />
      </Grid>
    </Grid>
  );
};

export default DynamicLoadProgressContainer;
